module.exports = __webpack_public_path__ + "static/media/number-guesser.8b068312.JPG";